import styled, { css } from 'styled-components';

import { CommonDivButton } from '../../styledComponents/buttons';

export const Tabsection = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 25px;
  justify-content: start;
  margin: 0 -40px;
  padding: 0 40px;
  border-bottom: ${({ theme }) =>
    `2px solid ${theme.colors.border.secondaryLight}`};
`;
export const TitleTag = styled.div`
  padding: 5px 10px;
  border-bottom: 2px solid;
  border-color: ${({ active, theme }) =>
    active ? theme.colors.main.primary : theme.colors.border.secondaryLight};
  position: relative;
  top: 2px;
  cursor: pointer;
`;
export const InfoMapSection = styled.div`
  display: grid;
  grid-template-columns: 462px 1fr;
`;
export const InfoSection = styled.div`
  padding: 20px;
  overflow: hidden;
`;

export const ZoneButton = styled(CommonDivButton)`
  min-height: 36px;
  color: ${({ active, theme }) =>
    active ? 'white' : theme.colors.main.textMain};
  background-color: ${({ bgColor, active, theme }) =>
    bgColor ? bgColor : active ? theme.colors.main.textMain : ''};
  font-size: ${({ theme }) => theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.button.sandButton.fontWeight};
  padding: 0 12px;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  width: max-content;
  align-items: center;
  border-radius: 6px;
  &:hover {
    border-color: ${({ theme }) => theme.button.primary.bgColor};
  }
`;

export const OfficeItemsTable = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 15px;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: ${({ heading, theme }) =>
    heading && `1px solid ${theme.colors.border.secondary}`};

  :nth-of-type(even) {
    background-color: ${({ heading }) => !heading && `#f8f9fc`};
  }
  /* Align last three columns to center */
  & > :nth-child(n + 2) {
    justify-self: center;
  }
  /* Alignment for the very last column */
  /* & > :last-child {
    display: flex;
    justify-self: start;
    align-items: center;
  } */
`;

export const ImagePreview = styled.div`
  margin-top: 10px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;

  img {
    max-width: 100%;
    width: 100%;
  }

  &:hover .delete-icon-container {
    display: block !important;
  }
`;

export const DeleteIconContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
  padding: 2px;
  background-color: white;
  border-radius: 50%;
`;

export const OfficeListTable = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 150px;
  grid-column-gap: 15px;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: ${({ heading, theme }) =>
    heading && `1px solid ${theme.colors.border.secondary}`};

  :nth-of-type(even) {
    background-color: ${({ heading }) => !heading && `#f8f9fc`};
  }
  & > :nth-child(n + 0) {
    justify-self: center;
  }
  /* & > :last-child {
    display: flex;
    justify-self: start;
    align-items: center;
  } */
`;

export const OfficeDetailsSingleInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const InfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;
  width: 100%;
  max-width: 1300px;
`;
export const InfoSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
